import React, { useState, useEffect } from "react";
import AddnExport from "../sub-components/Add-Export";
import DataTable from "react-data-table-component";
import { ActivePill, InactivePill } from "../sub-components/StatusPill";
import { useNavigate } from "react-router-dom";
import Search from "../sub-components/Search";
import TableActions from "../sub-components/TableActions";
import { StockService } from "../../../../services/StockService";
import moment from "moment";
const Species = () => {
  const navigate=useNavigate()
  const speciesColumns = [
    {
      name: "Name",
      selector: (row) => row.speciesName,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Number Of Trees",
      selector: (row) => row.totalNumberOfTrees,
    },
    {
      name: "Volume (m³)",
      selector: (row) => row.volume ?? "—",
    },
    {
      name: "Location",
      selector: (row) => locationOf(row),
      wrap: true,
    },
    {
      name: "Active",
      selector: (row) => row.isActive?<ActivePill >Active</ActivePill>:<InactivePill>Inactive</InactivePill>,
    },
    {
      name: "Date",
      selector: (row) => moment(row.dateCreated).format('yyyy-MM-DD'),
    },
    {
      name:'Actions',
      selector:(row)=><div>
        <TableActions viewAction={()=>navigate(`${row.speciesId}`)} deleteAction={()=>window.confirm(`Are you sure you want to delete this species`)} />
      </div>
    }
  
  ];
  const [concessions, setConcessions] = useState([]);
  useEffect(() => {
    StockService.GetAllConcessions().then((res) => setConcessions(res || []));
  }, []);
  const locationOf = (row) => {
    const concession = concessions.find((c) => c.concessionId === row.concessionId);
    const compartment = concession?.compartments?.find((c) => c.compartmentId === row.compartmentId);
    const concessionName = row.concessionName || concession?.concessionName;
    const compartmentName = row.compartmentName || compartment?.compartmentName;
    if (!concessionName) return "—";
    return compartmentName ? `${concessionName} / ${compartmentName}` : concessionName;
  };
  const [species,setSpecies] = useState([])
  useEffect(() => {
    handleSpecies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
     
  const [pending, setPending] = useState(true);
  const handleSpecies = () => {
    StockService.GetAllSpecies().then((res) => {
      
      setSpecies(...species, res);
      setPending(false);
      // console.log(concessions)
      
    });
  };
  const [search,setSearch] = useState("");
  const handleSearch = (event) => {
    setSearch(event.target.value); 
  };
  return (
    <div className="w-full">
      <AddnExport />
      <Search updateList={handleSearch} />
      <DataTable
        className="w-full rounded rounded-lg"
        columns={speciesColumns}
        // data={data}
        data={species.filter((item) => {
          if (search === "") {
            return item;
          } else{
           return item.description.toLowerCase().includes(search.toLowerCase())||
           item.speciesName.toLowerCase().includes(search.toLowerCase())
           
          } 
        })}
        progressPending={pending}
        pagination
      />
    </div>
  );
};

export default Species;
